import { render, staticRenderFns } from "./LoanAmountLedgerComponent.vue?vue&type=template&id=d4ba0088&"
import script from "./LoanAmountLedgerComponent.vue?vue&type=script&lang=js&"
export * from "./LoanAmountLedgerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports